import type { RequestResponse } from '@/types/publicType'
import type { loginInterface, ticketInterface } from '@/types/apiType/loginType'

/**
 * 测试环境登录
 * @param {number} unionid
 * @param {string} country 国家代码
 * @param {string} gclid 广告来源
 * @param {string} deviceId 设备ID
 * @param {string} app 项目名称
 */
export function apiLoginTest(params: {
  unionid: number
  country: string
  gclid: string
  deviceId: string
  app: string
}): Promise<RequestResponse<loginInterface>> {
  return getFetchData({
    url: '/acc/h5/login/google',
    method: 'GET',
    params,
    loading: true
  })
}

/**
 * 谷歌登录
 * @param {string} idToken
 * @param {string} displayName
 * @param {string} photoURL
 * @param {string} deviceId 设备唯一iD
 * @param {string} country 国家代码
 * @param {string} gclid 广告来源
 * @param {string} app 项目名称
 */
export function apiLoginGoogle(data: {
  idToken: string
  displayName: string
  photoURL: string
  deviceId: string
  country: string
  gclid: string
  app: string
}): Promise<RequestResponse<loginInterface>> {
  return getFetchData({
    url: '/acc/h5/login',
    method: 'POST',
    data,
    loading: false
  })
}

/**
 * 获取ticket
 * @param {string} access_token
 */
export function apiGetTicket(params: {
  access_token: string
}): Promise<RequestResponse<ticketInterface>> {
  return getFetchData({
    url: '/oauth/web/ticket',
    method: 'GET',
    params,
    loading: false
  })
}

/**
 * Apple登录
 * @param {string} idToken
 * @param {string} displayName
 * @param {string} photoURL
 * @param {string} deviceId 设备唯一iD
 * @param {string} country 国家代码
 * @param {string} gclid 广告来源
 * @param {string} app 项目名称
 */
export function apiLoginApple(data: {
  idToken: string
  displayName: string
  photoURL: string
  deviceId: string
  country: string
  gclid: string
  app: string
}): Promise<RequestResponse<loginInterface>> {
  return getFetchData({
    url: '/acc/h5/login/apple',
    method: 'POST',
    data,
    loading: false
  })
}
